module.exports = __webpack_public_path__ + "static/media/HDD.fc834e51.jpg";